import { render, staticRenderFns } from "./InprogressShops.vue?vue&type=template&id=edfd5224&scoped=true"
import script from "./InprogressShops.vue?vue&type=script&lang=ts"
export * from "./InprogressShops.vue?vue&type=script&lang=ts"
import style0 from "./InprogressShops.vue?vue&type=style&index=0&id=edfd5224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfd5224",
  null
  
)

export default component.exports